import { Coords } from 'google-map-react';

import { polylineDecoder } from '../locationUtils';
import {
  DirectionTypes,
  DistanceMatrixTypes,
  LocationOriginalDataTypes,
  LocationTypes,
  MapLocationInfoTypes,
  MapLocationTypes,
} from '../../types';
import { LOCATION_GEO_JSON_TYPES } from '../../commons/constants';
import { MapLocationResponseTypes } from '../../types/response';

export const convertDirection = (jsonStr: string): DirectionTypes => {
  if (!jsonStr) return null;

  let direction: DirectionTypes;
  try {
    direction = JSON.parse(jsonStr);

    if (direction.routes && !!direction.routes.length) {
      direction.routes = direction.routes.map((route) => ({
        ...route,
        legs: route.legs.map((leg) => ({
          ...leg,
          steps: leg.steps.map((step) => ({
            ...step,
            travel_mode: 'DRIVING',
            path: polylineDecoder(step.polyline.encodedPath),
          })),
        })),
      }));
    }
  } catch (e) {
    console.warn(e);
  }

  return direction;
};

export const convertDistanceMatrix = (jsonStr: string): DistanceMatrixTypes => {
  if (!jsonStr) return null;

  let distanceMatrix: DistanceMatrixTypes;
  try {
    distanceMatrix = JSON.parse(jsonStr);
  } catch (e) {
    console.warn(e);
  }

  return distanceMatrix;
};

export const convertGeoCoordinates = (jsonStr: string): any => {
  let geoCoordinates: any;

  try {
    // type is 'polygon', type is [lng: number, lat: number][]
    geoCoordinates = JSON.parse(jsonStr);
  } catch (e) {
    console.warn(e);
  }

  // otherwise, type is [lng: number, lat: number]
  return geoCoordinates;
};

export const convertMapLocationResponse = (
  item: MapLocationResponseTypes,
  parentKey: number
): MapLocationTypes => {
  const direction = convertDirection(item.direction);
  const distanceMatrix = convertDistanceMatrix(item.distanceMatrix);

  let geoCoordinates: any;
  let geoLocation: Coords;
  if (item.mapLocationInfo && item.mapLocationInfo.geoCoordinates) {
    geoCoordinates = convertGeoCoordinates(item.mapLocationInfo.geoCoordinates);
  }

  if (
    (geoCoordinates as [lng: number, lat: number]) &&
    item.mapLocationInfo &&
    item.mapLocationInfo.geoType === LOCATION_GEO_JSON_TYPES.POINT
  ) {
    geoLocation = { lat: geoCoordinates[1], lng: geoCoordinates[0] };
  }

  let mapLocationInfo: MapLocationInfoTypes;
  if (item.mapLocationInfo) {
    let location: LocationTypes;
    let category: string;
    let categories: string[];

    if (item.mapLocationInfo.location) {
      let originalData: LocationOriginalDataTypes;

      if (item.mapLocationInfo.location.originalData) {
        try {
          originalData = JSON.parse(item.mapLocationInfo.location.originalData);
        } catch (e) {
          console.warn(e);
        }
      }

      if (item.mapLocationInfo.location.tags && !!item.mapLocationInfo.location.tags.length) {
        category = item.mapLocationInfo.location.tags[0];
      }

      location = { ...item.mapLocationInfo.location, originalData };
    }

    if (item.mapLocationInfo.categories && !!item.mapLocationInfo.categories.length) {
      categories = item.mapLocationInfo.categories.map((i) => i.code);
    }

    mapLocationInfo = {
      ...item.mapLocationInfo,
      location,
      category,
      categories,
      geoCoordinates: geoLocation || geoCoordinates,
    };
  }

  return {
    id: +`${item.id}${parentKey}`,
    orderIndex: item.orderIndex,
    direction,
    distanceMatrix,
    mapLocationInfo,
  };
};
